/**
 * Constants and configuration for chat functionality
 */

export const DEFAULT_MODELS = [
    { id: 'GPT-4.1-MINI', name: 'GPT-4.1-MINI' },
    { id: 'GPT-4', name: 'GPT-4' },
    { id: 'GPT-4O', name: 'GPT-4O' },
    { id: 'GPT-4O-MINI', name: 'GPT-4O-MINI' },
    { id: 'GPT-4-TURBO', name: 'GPT-4-TURBO' },
];

export const SYSTEM_MESSAGES = [
    'Processing your request...',
    'Analyzing your message...',
    'Thinking about the best response...',
    'Generating response...',
    'Working on it...',
    'Let me help you with that...',
    'One moment please...',
    'Preparing response...',
];

export const MODEL_INIT_DELAY = 300; // ms to wait for model dropdown initialization

export const MAX_GENERATIONS_PER_MESSAGE = 3;



export const COMMAND_SCHEDULER_JOB_NAME = 'command_team.run_scheduled_ai_generation';


export const COMMAND_SCHEDULER_ENTITY_TYPE = 'command_agent';

export const COMMAND_SCHEDULER_SESSION_ENTITY_TYPE = 'command_session';

export const COMMAND_SCHEDULER_SCHEDULE_TYPE = 'one_time';

export const COMMAND_SCHEDULER_SCHEDULE_TYPE_RECURRING = 'cron';


export const COMMAND_SCHEDULER_SESSION_MODE = 'append';

export const COMMAND_SCHEDULER_API_PATH = '/api/schedular';


export const COMMAND_SCHEDULER_MIN_LEAD_MS = 60_000;

